export default class CorporateSearchModel {
  title: string;
  subTitle: string;
  fullName: string;
  newSearch: string;
  searchLink: string;
}